import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTitleConfigurationPayload } from "../utils/types";
import { apiFetch } from "@core/index";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";

// Create a new title configuration
export const useCreateTitleConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: {
      payload: CreateTitleConfigurationPayload;
    }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}`, {
        method: "POST",
        body: config.payload,
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message || "", {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Title configuration created successfully", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["titleConfigurationList"] });
      }
    },
    onError: (error: Error) => {
      console.error(
        "Failed to create a new title configuration:",
        error.message,
      );
    },
  });
};
